module.exports = __webpack_public_path__ + "static/img/banner.8cac5c5f.jpg";